export const TT_PAGES = ["/tt/promo/"];

export const RIBBON_MAP: { [key: string]: { copy: string; href: string | null } } = {
  subpush: {
    copy: "Put your hair growth plan on autopilot with a Nutrafol subscription <br class='block md:hidden'/> and  <span class='font-dinamoBold'>see results in as little as 3 months.</span>",
    href: null,
  },
  pick_your_booster: {
    copy: "{name}, celebrate with a free booster. <span class='font-dinamoBold'>Pick yours!</span>",
    href: "/account/rewards/?traffic_source=pencil_banner",
  },
  pay_it_forward: {
    copy: "{name}, keep growing with $5 off. <span class='font-dinamoBold'>Apply now!</span>",
    href: "/account/rewards/?traffic_source=pencil_banner",
  },
  upgrade_booster: {
    copy: "{name}, save 5% on renewals. <span class='font-dinamoBold'>Add your booster!</span>",
    href: "/account/rewards/?traffic_source=pencil_banner",
  },
  free_gift: {
    copy: "{name}, celebrate with a gift. <span class='font-dinamoBold'>Pick yours now!</span>",
    href: "/account/rewards/?traffic_source=pencil_banner",
  },
  refer_a_friend: {
    copy: "{name}, <i>refer friends and save!</i>",
    href: "/account/rewards/?traffic_source=pencil_banner",
  },
  ribbon_products: {
    copy: "Shop All Products",
    href: "/hair/brand/product/category/",
  },
  serum: {
    copy: "Nutrafol Men + Hair Serum for visible results in as little as 3 months.",
    href: "/hair/men/product/kit/core-hair-serum/",
  },
} as const;
